import './header.js';
import './navigation.js';
import './create-object.js'; // creatio lib
import './creatio-forms.js';

document.addEventListener('DOMContentLoaded', function () {

  const link = document.querySelector('.single-event__top-btn');
  const targetBlock = document.querySelector('.contact-section__form-block');
  if (link && targetBlock) {

    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetBlockTop = targetBlock.getBoundingClientRect().top + window.pageYOffset;
      const offset = 100;
      window.scrollTo({
        top: targetBlockTop - offset,
        behavior: 'smooth',
      });
    });
  }

  const lazyVideos = document.querySelectorAll('.lazy-video-wrapper');
  if (lazyVideos.length > 0) {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          let videoElement = document.createElement('video');
          if (typeof entry.target.dataset.videoAttributes !== 'undefined' && entry.target.dataset.videoAttributes.length > 0) {
            let attributes = JSON.parse(entry.target.dataset.videoAttributes);
            Object.assign(videoElement, attributes);
          }
          videoElement.classList = entry.target.dataset.videoClass;

          videoElement.addEventListener('loadeddata', () => {
            entry.target.classList.add('loaded');
            setTimeout(function () {
              let picture = entry.target.querySelector('picture');
              if(picture != null) {
                picture.remove();
                return;
              }

              let img = entry.target.querySelector('img').remove();
              if(img != null) {
                img.remove();
              }
            }, 300);
          });

          videoElement.src = entry.target.dataset.video;
          videoElement.type = 'video/mp4';

          entry.target.appendChild(videoElement);
        }
      });
    }, {
      root: document.querySelector('#page'),
      rootMargin: '0px',
      threshold: 1.0,
    });
    lazyVideos.forEach(videoWrapper => {
      setTimeout(() => {
        observer.observe(videoWrapper);
      }, 1000);
    });
  }
});